<script>
import CMSListCard from "@/views/components/cms/CMSListCard.vue";

export default {
  name: "AktuellesList",
  components: {CMSListCard},
  data() {
    return {
      tableItems: null,
      tableHeader: [
        {
          title: "article",
          label: "Titel",
        },
        {
          title: "creator",
          label: "Erstellt von",
        },
        {
          title: "description",
          label: "Beschreibung",
        },
        {
          title: "Action",
          label: "Aktionen",
        }
      ]
    };
  },
}
</script>

<template>
  <CMSListCard
      title="Aktuelle Informationen"
      new-button-name="Neue Information"
      :list-header="tableHeader"
      :category=9
      :event-to-call-options="{
        table: tableItems,
        showPath: 'Aktuelles',
        redirectPath: 'AktuellesEdit',
        categoryId: 9,
        deletePath: 'cms/deleteArticle',
        getPath: 'cms/getArticlesByCategory',
        textDelete: 'Artikel wurde erfolgreich gelöscht!',
        textDefaultData: 'aktuelles'
      }"
   new-button-path="AktuellesNew"></CMSListCard>
</template>

<style scoped>

</style>
